(() => {
  const root = document.querySelector('.jbg-editorial');
  if (!root) return;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  root.addEventListener('click', event => {
    const link = event.target.closest('a');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || link.target || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || url.hash || reducedMotion.matches) return;
    const book = root.querySelector('.journey-book');
    if (!book || window.scrollY > window.innerHeight * .5) return;
    event.preventDefault();
    if (book.classList.contains('is-leaving')) return;
    book.classList.add('is-leaving');
    window.setTimeout(() => location.assign(url.href), 550);
  });
})();
